import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesWorkflowTransitionRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-workflow-transition',
	path: '/secure/admin/ViewWorkflowTransition.jspa',
};
